import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-descarga-fichero-concesionario',
  templateUrl: './descarga-fichero-concesionario.component.html',
  styleUrls: ['./descarga-fichero-concesionario.component.sass']
})
export class DescargaFicheroConcesionarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
